import Vue from 'vue';

Vue.filter('fileSizeFormat', (bytes) => {
  if (typeof bytes !== 'number') return '0 Kb';
  if (Math.abs(bytes) < 1024) return `${bytes} B`;
  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let unitIndex = -1;
  do {
    bytes /= 1024;
    unitIndex += 1;
  } while (Math.round(Math.abs(bytes) * 10) / 10 >= 1024 && unitIndex < units.length - 1);
  return `${parseFloat(bytes.toFixed(2))} ${units[unitIndex]}`;
});
Vue.filter('formatDate', (date) => {
  const d = new Date(date);
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
});
